//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useState, useRef } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  CardHeader,
  CardContent,
} from '@mui/material';

// === COMPONENTS ===
import { LogoutButton } from '../LogoutButton/LogoutButton' ;
import { ThemeToggle  } from '../ThemeToggle/ThemeToggle'   ;
import { UserIcon     } from './UserIcon/UserIcon'          ;
import { VersionButton } from '../VersionButton/VersionButton' ;
import { Divider } from '../../../../node_modules/@mui/material/index';
import { Spacer } from 'components/Spacer';

// === HOOKS ===
import { useSession, OnlineStatus } from 'pages/PageManager/components/SessionContext';


//#endregion

//-----------------------------------------------------------------
export function UserNav() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { user_details, online_status } = useSession();

  const ref    = useRef();
  const theme  = useTheme();

  const [ is_open , setIsOpen  ] = useState(false);
  const [ color   , setColor   ] = useState( theme.palette.primary.main );
  const [ message , setMessage ] = useState( '' );

  const _styles = {
    container: {
      height: '100%',
      width: '5rem',
      display: 'block',
      marginTop: '6px',
      zIndex: '120',
      flexShrink: 0,
    },
    dropdown: {
      display: is_open ? '' : 'none',
      top: '5.5rem',
      right: '0.5rem',
      position: 'absolute',
      padding: 0,
    },
    info: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: '-0.5px 0.5px 3px black',
      width: '100%',
      padding: 0,
      borderRadius: 2,
      
      "&:last-child": {
        paddingBottom: 0,
     },
    }
  }

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    if(is_open) document.addEventListener   ( 'click', handleClickOutside, true );
    else        document.removeEventListener( 'click', handleClickOutside, true );

    return () => {
      if(is_open) document.removeEventListener('click', handleClickOutside, true);
    };
  }, [is_open]);

  useEffect( () => {
    switch( online_status ) {
      case OnlineStatus.DEFAULT : {
        setMessage('');
        setColor( theme.palette.primary.main );
      } break;
      case OnlineStatus.DISCONNECTED : {
        setMessage('Disconnected');
        setColor( theme.palette.error.main );
      } break;
      case OnlineStatus.RECONNECTING : {
        setMessage('Reconnecting');
        setColor( 'orange' );
      } break;
      case OnlineStatus.RECONNECT_FAIL : {
        setMessage('Disconnected');
        setColor( theme.palette.error.main );
      } break;
      case OnlineStatus.CONNECTED : {
        setMessage('Connected');
        setColor( theme.palette.success.main );
      } break;
    }
  }, [online_status] );

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  const toggleDetails = () => {
    //-----------------------------------------------------------------
    setIsOpen(!is_open);
  };

  //-----------------------------------------------------------------
  function handleClickOutside(event) {
    //-----------------------------------------------------------------
    if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
    }
  }

  //#endregion
  
  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return user_details ? display_A() : <LogoutButton />
  };

  //-----------------------------------------------------------------
  function display_A() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} ref={ref}>
        <UserIcon color={color} onClick={toggleDetails}/> 
        <Box sx={_styles.dropdown}>
          <CardContent sx={_styles.info} >
            <CardHeader sx={ _styles.main } title={user_details.display_name} subheader={user_details.Email} />
            <div style={{ display: 'flex' }}>
              <Spacer />
              Online status:
              <Spacer />
              <div style={{ color: color }}>{message}</div>
            </div>
            <Divider />
            <ThemeToggle  />
            <Divider />
            <VersionButton />
            <Divider />
            <LogoutButton />
            <Divider />        
          </CardContent>
        </Box>
      </Box>
    );
  }


  //#endregion

  return display();
}
